define('models/Podio.Models.ChatShowMore',['require','lib/backbone/Backbone.PodioModel'],function(require) {

  var PodioModel = require('lib/backbone/Backbone.PodioModel');

  return PodioModel.extend({

    initialize: function(options) {
      this.set('totalUnreadCount', options.totalUnreadCount);
      this.set('conversations', options.conversations);

      this._calculateShowMoreUnreadCount();
      this._bindEvents();
    },

    _bindEvents: function() {
      this.listenTo(this, 'change:totalUnreadCount', this._calculateShowMoreUnreadCount);
    },

    _calculateShowMoreUnreadCount: function() {
      var listUnreadCount = this.get('conversations').reduce(function(total, conversation) { return total + conversation.get('unread_count'); }, 0);
      var showMoreUnreadCount = this.get('totalUnreadCount') - listUnreadCount;
      this.set('listUnreadCount', listUnreadCount);
      this.set('showMoreUnreadCount', showMoreUnreadCount);
    },

  });

});

